const EditIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 2.5002H3.16667C2.72464 2.5002 2.30072 2.6758 1.98816 2.98836C1.67559 3.30092 1.5 3.72484 1.5 4.16687V15.8335C1.5 16.2756 1.67559 16.6995 1.98816 17.012C2.30072 17.3246 2.72464 17.5002 3.16667 17.5002H14.8333C15.2754 17.5002 15.6993 17.3246 16.0118 17.012C16.3244 16.6995 16.5 16.2756 16.5 15.8335V10.0002M14.3126 2.18769C14.6441 1.85617 15.0937 1.66992 15.5626 1.66992C16.0314 1.66992 16.4811 1.85617 16.8126 2.18769C17.1441 2.51921 17.3303 2.96885 17.3303 3.43769C17.3303 3.90653 17.1441 4.35617 16.8126 4.68769L9.30175 12.1994C9.10387 12.3971 8.85942 12.5418 8.59091 12.6202L6.19674 13.3202C6.12504 13.3411 6.04903 13.3424 5.97667 13.3238C5.90431 13.3053 5.83827 13.2676 5.78545 13.2148C5.73263 13.162 5.69499 13.096 5.67645 13.0236C5.65791 12.9512 5.65916 12.8752 5.68008 12.8035L6.38008 10.4094C6.45885 10.1411 6.60386 9.8969 6.80174 9.69936L14.3126 2.18769Z"
      stroke="#5C757D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
